import { render, staticRenderFns } from "./_qv-last-purchase.vue?vue&type=template&id=0ba640a8&scoped=true"
import script from "./_qv-last-purchase.vue?vue&type=script&lang=js"
export * from "./_qv-last-purchase.vue?vue&type=script&lang=js"
import style0 from "./_qv-last-purchase.vue?vue&type=style&index=0&id=0ba640a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba640a8",
  null
  
)

export default component.exports